export enum MppCurrencies {
  EUR = 'eur',
  USD = 'usd',
}
